module.exports = __webpack_public_path__ + "img/yobee-logo-text.6d99fb74.png";